import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Observable} from "rxjs";
import {Message} from "@stomp/stompjs";
import {isPlatformBrowser, isPlatformServer} from "@angular/common";
import {RxStomp, RxStompConfig} from "@stomp/rx-stomp";
import { environment } from "src/environments/environment";
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable({
  providedIn: 'root'
})
export class WebsocketService extends RxStomp {
  constructor(private cookieService: SsrCookieService,
              @Inject(PLATFORM_ID) private platformId: object) {
    super()
  }

  initWebSocket() {
    if(!this.isConnected()) {
      const stompConfig: RxStompConfig = {
        // Which server?
        brokerURL: environment.wsUrl,

        connectHeaders: {
          Authorization: this.cookieService.get("auth-token")
        },
        // Heartbeats (ms). Set 0 to disable.
        heartbeatIncoming: 0,
        heartbeatOutgoing: 20000,

        // Reconnect delay (ms). Set 0 to disable.
        reconnectDelay: 2000
      };

      this.configure(stompConfig);
      this.activate();
    }
  }

  deacticate() {
    if(isPlatformBrowser(this.platformId)) {
      this.deactivate();
    }
  }

  isConnected(): boolean {
    if(isPlatformServer(this.platformId)) {
      return false;
    }
    return this.connected()
  }

  // Need add unsubscribe when leave page
  subscribeChat(orderId: number): Observable<Message> {
    if(isPlatformServer(this.platformId)) {
      return
    }
    this.initWebSocket()
    return this.watch(`/user/queue/chat/${orderId}`);
  }

  sendChatMessage(message: string, orderId: number) {
    if(isPlatformServer(this.platformId)) {
      return
    }
    this.initWebSocket()
    this.publish({
      destination: `/app/chat/${orderId}`,
      body: message,
    });
  }
}
